<template>
    <div
        style="margin-top: 20px; margin-bottom: 10px; font-size: .8rem; display: flex; justify-content: center; align-items: center;">
        <p style="width: 80%; color: #979797;">免责声明：本站部分内容来源于网络，图片版权属于原作者，本站转载仅供大家交流学习，切勿用于任何商业用途；
            本站不承担用户因使用这些资源对自己和他人造成任何形式的损害或伤害；如果侵犯了您的合法权益，请您及时与我们联系，我们会在第一时间删除相关内容。</p>
    </div>
</template>